import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=26c952cd&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/post/Post/PostStyle.css?vue&type=style&index=0&id=26c952cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c952cd",
  null
  
)

export default component.exports